/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InvoiceStatus
 */
export interface InvoiceStatus {
    /**
     * 
     * @type {string}
     * @memberof InvoiceStatus
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof InvoiceStatus
     */
    facility_id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InvoiceStatus
     */
    due_date: string;
}

/**
 * Check if a given object implements the InvoiceStatus interface.
 */
export function instanceOfInvoiceStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "due_date" in value;

    return isInstance;
}

export function InvoiceStatusFromJSON(json: any): InvoiceStatus {
    return InvoiceStatusFromJSONTyped(json, false);
}

export function InvoiceStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'facility_id': !exists(json, 'facility_id') ? undefined : json['facility_id'],
        'due_date': json['due_date'],
    };
}

export function InvoiceStatusToJSON(value?: InvoiceStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'facility_id': value.facility_id,
        'due_date': value.due_date,
    };
}

